import { AlertCircle, RefreshCw } from 'lucide-react';
import { Card } from './Card';
import { Button } from './Button';

export interface ErrorCardProps {
  title?: string;
  message?: string;
  onRetry?: () => void;
  retryLabel?: string;
  className?: string;
}

export function ErrorCard({
  title = 'Algo deu errado',
  message = 'Não foi possível carregar os dados. Tente novamente.',
  onRetry,
  retryLabel = 'Tentar novamente',
  className,
}: ErrorCardProps) {
  return (
    <Card className={`max-w-md mx-auto text-center p-8 ${className || ''}`}>
      <AlertCircle className="w-12 h-12 mx-auto mb-4 text-red-400" />
      <h2 className="text-xl font-semibold text-surface-100 mb-2">{title}</h2>
      <p className="text-surface-400 mb-4">{message}</p>
      {onRetry && (
        <Button onClick={onRetry} variant="secondary">
          <RefreshCw className="w-4 h-4 mr-2" />
          {retryLabel}
        </Button>
      )}
    </Card>
  );
}

export default ErrorCard;
